export function buildRequestPagesPageQueryV1(workspaceId: number, projectId: number)
{
	return {
		'$type': 'TCh.Domain.Pages.Queries.RequestPagesPageQueryV1, TCh.Domain.Pages',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
	}
}

export function buildRequestPageEditorPageQueryV1(workspaceId: number, projectId: number, pageId: number)
{
	return {
		'$type': 'TCh.Domain.Pages.Queries.RequestPageEditorPageQueryV1, TCh.Domain.Pages',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'PageId': pageId,
	}
}


export function buildRequestPageViewerPageQueryV1(accessKey: string)
{
	return {
		'$type': 'TCh.Domain.Pages.Queries.RequestPageViewerPageQueryV1, TCh.Domain.Pages',
		'AccessKey': accessKey,
	}
}
